export default "__VITE_ASSET__CiYlPF4O__"